export const TMDB_API_KEY = "95f2419536f533cdaa1dadf83c606027";
export const APP_DOMAIN = "https://donflix.pages.dev/";
export const APP_PROXIES = [
  "https://worker-curly-cake-a086.moovtuga.workers.dev/"
];
export const APP_OPENSUBTITLES_API = "https://opensubtitles.soneme7359.workers.dev/?destination=";
